export const MAX_VOLUME = 1;
export const MUTE_VOLUME = 0;
